import { FC } from "preact/compat";
import { getOcrColor } from "~/core/color-manager";
import { FigureItemProps } from "./interfaces";
import { getCoords } from "./utils";

const FigureItem: FC<FigureItemProps> = ({ figure }) => {
    const coords = getCoords(figure.boundaries);

    if (coords.length < 1) {
        return null;
    }

    const pathD = coords
        .map(([x, y], i) => (i === 0 ? `M ${x} ${y}` : `L ${x} ${y}`))
        .concat(["Z"])
        .join(" ");
    const color = getOcrColor(figure.score);

    return (
        <path d={pathD} fill={`${color}55`} stroke={color} strokeWidth="1" />
    );
};

export default FigureItem;
